const actionTypes = {
  SAVE_SCROLL_LATEST_POSITION: 'SAVE_SCROLL_LATEST_POSITION',
  UPDATE_WINDOW_SCROLL_POSITION: 'UPDATE_WINDOW_SCROLL_POSITION',
};

export default actionTypes;



// WEBPACK FOOTER //
// ./app/UI/scroll/actionTypes.js